import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import playerImg from '@assets/images/placeholder/playerPagePlaceholder.svg'
import { getImgURL } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import styles from './style.module.scss'

const MyImage = dynamic(() => import('@shared/components/myImage'))

const AvoidPlayer = ({ fantasystyles, avoidPlayers }) => {
  return (
    <section className="common-section py-0">
      <h6 className="mt-0">
        Avoid These Players
      </h6>
      <Row className={`${styles.root} mb-xxl-3 gutter-9`}>
        {avoidPlayers &&
          avoidPlayers?.map((player, index) => (
            <Col key={index} xs={12} sm={12} xxl={6} className="mb-3 mb-xxl-0">
              <div className={`${styles.item} common-box w-100`}>
                <div className={`${styles.imgBlock} flex-shrink-0 text-center`}>
                  <MyImage
                    src={getImgURL(player?.oPlayerFan?.oPlayer?.oImg?.sUrl) || playerImg}
                    alt="user"
                    blurDataURL={BLUR_DATA_URL_BASE64}
                    placeholder="blur"
                    layout="responsive"
                    width="40"
                    height="40"
                  />
                </div>
                <div className={styles.playerInfo}>
                  <div className={`${styles.playerRow} align-items-center gap-2`}>
                    <span className="font-bold">{player?.oPlayerFan?.oPlayer?.sFirstName}</span>
                    {/* <p className={styles.badge}>{player?.oPlayerFan?.oPlayer?.sPlayingRole}</p> */}
                    <span className={styles.subtitle}>
                      <span>{player?.oPlayerFan?.oTeam?.sAbbr && player?.oPlayerFan?.oTeam?.sAbbr}</span>
                      <span className={styles.dotSymbol}></span>
                      <span className='text-capitalize'>{player?.oPlayerFan?.oPlayer?.sPlayingRole}</span>
                    </span>
                    <div className={`${styles.point} rounded-pill`}>
                      <span>X Avoidable</span>
                    </div>
                  </div>
                  {player?.sDescription && <p className={`${styles.desc} mb-0 mt-1`}>{player?.sDescription}</p>}
                </div>
              </div>
            </Col>
          ))}
      </Row>
    </section>
  )
}

AvoidPlayer.propTypes = {
  fantasystyles: PropTypes.any,
  avoidPlayers: PropTypes.array,
  playerData: PropTypes.array
}

export default AvoidPlayer
